/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { updatePriceSizeSchema } from "./updatePriceSizeSchema.ts";

export const menuDeltaProductSchema = z
	.object({
		product: z.uuid(),
		price: z.number().nullish(),
		priceSizes: z.array(updatePriceSizeSchema).optional(),
	})
	.describe(
		"Изменённая позиция в дельте: присылают только те поля, что поменялись.\n\nДефолтов у необязательных полей нет намеренно — иначе пакет без ``priceSizes``\nприехал бы с пустым списком и погасил все размерные цены блюда.",
	);
